export const MOBILE_BLOCK_SETTING_EVENT = 'oms:mobile-block-updated';

export const emitMobileBlockSettingUpdate = (enabled) => {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(MOBILE_BLOCK_SETTING_EVENT, { detail: { enabled: Boolean(enabled) } }));
};
